import { render } from "./SponsorEditPage.vue?vue&type=template&id=06cdb35b&scoped=true"
import script from "./SponsorEditPage.vue?vue&type=script&lang=js"
export * from "./SponsorEditPage.vue?vue&type=script&lang=js"

import "./SponsorEditPage.vue?vue&type=style&index=0&id=06cdb35b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cdb35b"]])

export default __exports__